var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm.isAuthenticated
        ? _c(
            "div",
            [
              _c("AppHeader"),
              _c("section", { staticClass: "main-menu navbar-space" }, [
                _c("div", { staticClass: "container" }, [
                  _vm._m(0),
                  _vm.appList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "row justify-content-center" },
                        [
                          _c("div", { staticClass: "col-12 col-xs-fix" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "purchase-table-wrapper table-wrapper"
                              },
                              [
                                _c(
                                  "table",
                                  { staticClass: "purchase-table table" },
                                  [
                                    _vm._m(1),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.appList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: item.appId,
                                            staticClass: "main-row",
                                            attrs: { item: item, index: index }
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "security-img"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/resources/img/bene/" +
                                                          item.logoCd +
                                                          ".jpg"),
                                                        alt: ""
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "security-name"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.getRequestDetail(
                                                              item.reqNo
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.beneNameTh
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "name-cell small"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm.reqTypeMapping(
                                                                item.reqType
                                                              )
                                                            ) +
                                                            ")"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [_vm._v(_vm._s(item.reqNo) + " ")]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.lgTypeNameTh)
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "date-cell" },
                                              [_vm._v(_vm._s(item.createDt))]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "status-cell" },
                                              [
                                                item.status === "S"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-success"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("สำเร็จ")
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.status === "F"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-danger"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("ไม่สำเร็จ")
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.status === "W"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-wait"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "กำลังดำเนินการ"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.status === "R"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-danger"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "ไม่ผ่านเงื่อนไข"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "amt-cell" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "amt-cur" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          item.lgAmt
                                                        )
                                                      ) + " บาท"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c("b-pagination", {
                            attrs: {
                              size: "md",
                              "total-rows": _vm.totalRecord,
                              "per-page": 10
                            },
                            on: {
                              input: function($event) {
                                return _vm.getRequestHistory(_vm.currentPage)
                              }
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.appList.length === 0
                    ? _c("div", { staticClass: "row justify-content-center" }, [
                        _vm._m(2)
                      ])
                    : _vm._e()
                ])
              ]),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "secondary-title" }, [
          _c("h5", { staticClass: "title" }, [_vm._v("ประวัติการทำรายการ")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("รายการ")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("เลขที่ใบคำขอ")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ประเภท")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("วันที่ทำรายการ")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("สถานะ")]),
        _c("th", { staticClass: "amt-th", attrs: { scope: "col" } }, [
          _vm._v("วงเงินค้ำประกัน")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-xs-fix" }, [
      _c("div", { staticClass: "purchase-table-wrapper table-wrapper" }, [
        _c("table", { staticClass: "purchase-table table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [_vm._v("รายการ")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("เลขที่ใบคำขอ")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("ประเภท")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("วันที่ทำรายการ")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("สถานะ")]),
              _c("th", { staticClass: "amt-th", attrs: { scope: "col" } }, [
                _vm._v("วงเงินค้ำประกัน")
              ]),
              _c("th")
            ])
          ]),
          _c("tbody", [
            _c("tr", { staticClass: "empty-data" }, [
              _c("td", { attrs: { colspan: "999" } }, [
                _vm._v("ไม่มีข้อมูลประวัติการทำรายการ")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }